import { LSystem } from "./lsystem";

export class LSystemModelBuilder<STATE = any> {
    _rules = new Map<string, (state: STATE, params: number[]) => STATE>();
    _hooks = new Set<(state: STATE) => void>();
    constructor(
        private readonly options: {
            initialState: STATE;
        },
    ) {}

    addDrawingRule(
        symbol: string,
        cb: (state: STATE, params: number[]) => STATE,
    ) {
        this._rules.set(symbol, cb);
        return this;
    }

    addHook(cb: (state: STATE) => void) {
        this._hooks.add(cb);
        return this;
    }

    build(lsys: LSystem, iteration: number) {
        const lsysout = lsys.iteration(iteration);
        if (!lsysout) {
            return;
        }
        let nextState = this.options.initialState;

        for (const hook of this._hooks) {
            hook(nextState);
        }

        const tokens = tokenize(lsysout);

        tokens.forEach((token) => {
            const rule = this._rules.get(token.symbol);
            if (!rule) {
                throw Error("Missing rule for token: " + token.symbol);
            }

            nextState = rule(nextState, token.params);
        });
    }
}

type Token = {
    symbol: string;
    params: number[];
};

function tokenize(input: string): Token[] {
    const tokens: Token[] = [];
    const regex = /(\[|\]|[A-Za-z+\-*/])(?:\(([^()]*)\))?/g;
    let match;

    while ((match = regex.exec(input)) !== null) {
        const symbol = match[1];
        const rawParams = match[2];
        const params = rawParams
            ? rawParams.split(",").map(p => Number(p.trim()))
            : [];
        tokens.push({ symbol, params });
    }

    return tokens;
}
